import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PageDevice from '../../page/PageDevice';
import { getRoutes } from '../../routes/getRoutes';
import { PapsContext } from './PapsContext';
import { StartContext } from './StartContext';
import { CurrentSettingsContext } from './SettingsDataContext';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { RegDataContext } from './RegDataContext';
import { AppContext } from './AppProvider';
import { useRenders } from './useHelpers/useRenders';

export const RoutesContext = createContext();

const RoutesProvider = (props) => {

  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext ?? {}
  const { pathViews } = paps_state ?? {}
  const { events: eventKey } = pathViews ?? {}

  const isMobileDevice = _.get(app_state, 'currentEnvironment.platform.isMobileDevice', false)

  useRenders('RoutesProvider', true);

  // startContext
  const startContext = useContext(StartContext)
  const { start_handlers } = startContext ?? {}

  // currentSettingsContext
  const currentSettingsContext = useContext(CurrentSettingsContext)
  const { currentSettings_state } = currentSettingsContext ?? {}
  const { aps_views } = _.get(currentSettings_state, 'gvviSettings', {});

  const regDataContext = useContext(RegDataContext)
  const { regData_state } = regDataContext ?? {}
  const { isRegDemo, regInfo } = regData_state ?? {}

  // local state
  // const [viewRoutes, setViewRoutes] = useState()
  // const [genericRoutes, setGenericRoutes] = useState()

  // const routes_state = { viewRoutes, genericRoutes }

  const usePageTransitions = isMobileDevice ? true : false

  const genericRoutes = useMemo(() => {
    const _routes = getRoutes(
      <PageDevice />,
      usePageTransitions
    ).genericRoutes;
    return _routes
  }, []);

  const routes_state = { genericRoutes }

  const routesProvider = () => {
    return <RoutesContext.Provider value={{ routes_state }}>
      {props.children}
    </RoutesContext.Provider>
  }

  const noRoutes = () => {
    if (isRegDemo) {
      return <FullPageWrapper
        topperCaption={'Reg Demo'}
        content={<Wrapper
          header={`Fetching Reg Data for event ${eventKey}`}
          content={<div style={{ padding: '1em' }}>{'Please be patient...'}</div>}
          wrapperType={wrapperTypes.padded}
          css={{ container: 'app-dark-mode' }}
        ></Wrapper>}
      />
    } else {
      return <FullPageWrapper
        topperCaption={'Invalid Page'}
        content={<Wrapper
          header={'Page Not Found'}
          content={'No page exists for the selected page.'}
          wrapperType={wrapperTypes.padded}
          css={{ container: 'app-dark-mode' }}
        ></Wrapper>}
      />
    }
  }

  return genericRoutes ? routesProvider() : <div></div> // noRoutes()
}

export default RoutesProvider
